import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const TacticP2AMastercard = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-mastercard.jpg" xPos="80%" yPos="51%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Obročno plačevanje z več nadzora.</h1>
                    <p className="text-left">
                    Z Addiko Mastercard obročno kartico lahko vsakodnevne in večje nakupe razdelite na obroke – hitro, enostavno in brez dodatne papirologije.
                    </p>
                    <p className="text-left">
                      <b>Če bi radi izvedeli več, smo vam na voljo - izpolnite kontaktni obrazec in poskrbeli bomo, da prejmete dodatne informacije.</b>
                    </p>
                    <p className="text-left">
                      Če ste pripravljeni, lahko kartico začnete uporabljati že danes.
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="518fbd8e-38ce-4c20-a9fb-9b501e683582" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}